import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';

import EmploymentSubMenu from '@/components/nav/EmploymentSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import ExitPopup943X from '@/components/ui/ExitPopup943X';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form943X = () => {
  const [open, setOpen] = useState(false);
  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Don't miss your payroll tax return deadline.`,
  //   SubHeading:
  //     'E-file Form 940 for easy compliance. File now and save time and stress.',
  //   CtaText: 'E-file Form 940 Now',
  //   CtaSubHeading: `Stay tax compliant with the IRS`,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=sticky`,
  //   isActive: true,
  // };
  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-File Form 943-X Online | Amend Your 2025 Tax Errors"
          description="Amend your 2025 tax errors with ease by e-filing Form 943-X online with TaxZerone. Correct misreported wages, tax credits, and federal income tax for accuracy."
          keywords=""
          canonical="employment-tax/e-file-irs-form-943-x/"
          jsonLdPricing="6.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="54869"
          ogShareImg="assets/images/employment-share-img.png"
        />
      }
    >
      <ExitPopup943X />
      <EmploymentSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Last Day to E-File Forms 940!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <b>final day</b> to
              electronically file your <b>Form 940</b> (Annual Federal
              Unemployment Tax Return).
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      <Container maxWidth="xl">
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                E-File Your{' '}
                <span className="highlight-container">
                  <span className="highlight">Form 943-X</span>
                </span>{' '}
                for the Tax Year 2025
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 1,
                }}
              >
                Amend Your Agricultural Employer’s Annual Federal Tax Return
                Quickly and Accurately.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Ensure your agricultural employment tax returns are accurate and
                compliant with our easy-to-use platform.
              </Typography>

              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mr: { xs: 0, md: 4 },
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form943x`}
                  >
                    File Form 943-X Now
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes 3 steps and less than 5 minutes
                  </Typography> */}
                </Box>
                <Hidden mdDown>
                  <Box sx={{}}>
                    <picture>
                      <source
                        srcSet="/assets/images/irs-authorized.webp"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                      <source
                        srcSet="/assets/images/irs-authorized.png"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                      <img
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        className="mw-100"
                        width={70}
                        height={69}
                      />
                    </picture>
                  </Box>
                </Hidden>
              </Stack>
              <Box
                sx={{
                  position: 'relative',
                  maxWidth: 580,
                  mx: { xs: 'auto', md: 0 },
                  mt: 5,
                }}
              >
                {/* <Box
                  sx={{
                    background: '#333',
                    p: 1,
                    px: 2,
                    color: '#fff',
                    '&.ribbon:before': { left: 0 },
                    '&.ribbon:after': { right: 0 },
                  }}
                  className="ribbon"
                >
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        textAlign: { xs: 'center', sm: 'center' },
                        fontSize: { xs: 16, sm: 18, md: 20 },
                      }}
                    >
                      Form 941 for Quarter 3, 2023, is due on{' '}
                      <strong>October 31</strong>
                    </Typography>
                  </Box>
                </Box> */}
              </Box>
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/943x-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/943x-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/943x-landing-img.png"
                  alt="E-File Your Form 943-X for the Tax Year 2025"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/943x-landing-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/943x-landing-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/943x-landing-img-sm.png"
                  alt="E-File Your Form 943-X for the Tax Year 2025"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 30, md: 28, sm: 26, xs: 22 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                File Form 943-X online with the IRS at the lowest price.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                Get an affordable flat rate that ensures the best value without
                hidden fees. With us, what you see is what you get!
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              E-File securely for just
              <br />
              <Box
                component="strong"
                sx={{
                  color: '#ffe400',
                  fontSize: { xs: 30, sm: 36, md: 48, lg: 60 },
                }}
              >
                $6.99
              </Box>
              <br />
              <Button
                size="large"
                variant="contained"
                href="/pricing/#employment"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 5.5, lg: 5 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 5 }, mt: { xs: -3, md: 5 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What is Form 943-X?
                </Typography>

                <Typography variant="body1">
                  Form 943-X is a specialized IRS tax form called the{' '}
                  <span style={{ fontWeight: 600 }}>
                    Adjusted Employer&apos;s Annual Federal Tax Return for
                    Agricultural Employees or Claim for Refund
                  </span>
                  . Employers use it to correct errors on previously filed
                  returns, enabling them to make precise corrections to annual
                  federal tax returns for agricultural workers, modify wage
                  reporting, claim refunds, and resolve tax discrepancies
                  specific to agricultural employment.
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 6.5, lg: 7 }}>
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  my: { xs: 3, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/943x-img.webp" />
                  <source srcSet="/assets/images/943x-img.png" />
                  <img
                    src="/assets/images/943x-img.png"
                    alt="What is Form 943-X?"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={440}
                    height={394}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 0,
                  textAlign: 'center',
                }}
              >
                Why File Form 943-X?
              </Typography>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={2}
            m={2}
            mt={2}
            py={{ xs: 0, sm: 4, md: 7 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/error-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/error-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/error-icon.png"
                      alt="Amend Errors"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Amend Errors
                </Typography>
                <Typography variant="body1">
                  Correct the errors in the farm labor taxes recorded on the
                  Form 943 you previously filed.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/claim-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/claim-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/claim-icon.png"
                      alt="Claim Overpaid Taxes"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Claim Overpaid Taxes
                </Typography>
                <Typography variant="body1">
                  Request a refund or credit for overpaid Social Security,
                  Medicare, or withheld federal income taxes.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/penalty-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/penalty-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/penalty-icon.png"
                      alt="Avoid Penalties"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Avoid Penalties
                </Typography>
                <Typography variant="body1">
                  Correcting errors on Form 943 before the IRS notices can help
                  you avoid penalties and interest for incorrect or late
                  filings.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                File Form 943-X Quickly in Just Three Steps
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Follow these steps to quickly amend your IRS Form 943 errors and
                ensure compliance with the filing process.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
              }}
            >
              <picture>
                <source
                  srcSet="/assets/images/943x-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/943x-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/943x-steps-img.png"
                  alt="File Form 943-X Quickly in Just Three Steps"
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter Required Information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter Required Information
                    </Typography>
                    <Typography variant="body1">
                      Provide the details from your original Form 943 and any
                      adjustments that need to be made.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Review and Verify"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review and Verify
                    </Typography>
                    <Typography variant="body1">
                      Check your entries and verify the corrections to ensure
                      accuracy
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Submit Your Form 943-X"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Submit Your Form 943-X
                    </Typography>
                    <Typography variant="body1">
                      File your Form 943-X with the IRS securely and efficiently
                      through our platform.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form943x`}
                >
                  File Form 943-x
                </Button>
              </Box>
            </Box>
          </Stack>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why TaxZerone is Your Best Choice for Form 943-X Filing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                See how TaxZerone streamlines the filing of Form 943-X for your
                business.
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS-Authorized Provider"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS-Authorized Provider
                </Typography>
                <Typography variant="body1">
                  As an IRS-authorized e-file provider, TaxZerone ensures that
                  your corrections are processed professionally and accurately.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/filling-requiremnt-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/filling-requiremnt-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/filling-requiremnt-icon.png"
                      alt="Error-Free Filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Error-Free Filing
                </Typography>
                <Typography variant="body1">
                  Our comprehensive validation checks help reduce the risk of
                  errors, ensuring precise filings every time.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Efficient Processing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Efficient Processing
                </Typography>
                <Typography variant="body1">
                  Submit your corrections quickly and seamlessly with our
                  streamlined processing system.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/secure-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/secure-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="Secure and Trusted"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Secure and Trusted
                </Typography>
                <Typography variant="body1">
                  Your data is protected with advanced security technologies,
                  offering you peace of mind throughout the process.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Intuitive User Interface"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Intuitive User Interface
                </Typography>
                <Typography variant="body1">
                  Our platform is easy to navigate, providing step-by-step
                  guidance through the entire correction process.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/real-time-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/real-time-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/real-time-icon.png"
                      alt="Real-Time Notifications"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Real-Time Notifications
                </Typography>
                <Typography variant="body1">
                  Get immediate updates on your filing status, with
                  notifications for successful submissions and acceptance.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          Ready to simplify your tax corrections?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          E-file your Form 943-X with the IRS using TaxZerone and correct errors
          quickly.
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form943x`}
          >
            Start Filing Now
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What is the purpose of Form 943-X?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Form 943-X is used to correct errors on a previously filed
                    <Link
                      href="/resources/employment-tax/form-943-instructions/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 943
                    </Link>
                    , such as misreported wages, tax credits, and federal income
                    tax withheld. It helps correct underreported or overreported
                    taxes, ensuring the employer complies with IRS requirements.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. When should I file Form 943-X?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      File Form 943-X when you discover an error on a previously
                      filed Form 943. If you underreported tax, file by the due
                      date of the return for the period in which you discovered
                      the error. TaxZerone ensures you file promptly and
                      accurately, helping you avoid penalties.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Is there a deadline for filing Form 943-X?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      <b>Yes</b>, Form 943-X must be filed within 3 years of the
                      original Form 943 filing date or 2 years from the date you
                      paid the tax, whichever is later. If filing within the
                      last 90 days, you must use the claim process.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Can I use Form 943-X to correct Form 941 or other forms?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <b> No</b>, Form 943-X can only be used to correct errors on
                    <Link
                      href="/resources/employment-tax/form-943-instructions/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 943
                    </Link>
                    . For correcting{' '}
                    <Link
                      href="/resources/employment-tax/form-941-instructions/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 941
                    </Link>{' '}
                    or other forms like 944 or 945, use the corresponding
                    &quot;X&quot; form, such as{' '}
                    <Link
                      href="/resources/employment-tax/form-941-x-instructions/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 941-X
                    </Link>
                    , Form 944-X, or <br />
                    <Link
                      href="/resources/employment-tax/form-945-x-instructions/"
                      sx={{ color: '#0202ff' }}
                    >
                      Form 945-X
                    </Link>
                    , depending on the specific form that needs correction.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. Can I request a refund for overpaid taxes using Form 943-X?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      <b>Yes</b>, If you&apos;ve overpaid taxes, you can use
                      Form 943-X to request a refund or apply a credit to future
                      filings. TaxZerone helps you navigate the process, making
                      it easier to handle adjustments and ensure your filings
                      are accurate and timely.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  6. What are the benefits of filing Form 943-X?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      Filing Form 943-X offers several advantages for
                      agricultural employers, helping ensure compliance with tax
                      regulations and correcting errors promptly.
                    </Typography>
                    <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.5 } }}>
                      <li>
                        <b>Avoiding Penalties:</b> By filing Form 943-X on time,
                        you can prevent costly penalties, late fees, and the
                        risk of an IRS audit due to misreported information.
                      </li>
                      <li>
                        <b>Refunds and Credits:</b> If you overreported taxes,
                        filing Form 943-X allows you to receive a refund or
                        credit that can be applied to future tax filings.
                      </li>
                      <li>
                        <b>Accurate Employee Records:</b> Filing the correction
                        ensures your employee tax records remain accurate,
                        supporting correct tax credits and deductions for your
                        business.
                      </li>
                      <li>
                        <b>Simplified Future Filings:</b> Correcting mistakes
                        through Form 943-X improves the accuracy of future Form
                        943 filings, helping to avoid errors in upcoming tax
                        years.
                      </li>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form943X;
